// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 客服页面主容器 */
.customer-service-page {
  min-height: 100vh;
  background: var(--color-bg);
  display: flex;
  flex-direction: column;
}

/* 页面头部 */
.service-header {
  background: var(--color-surface);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: saturate(160%) blur(16px);
}

.back-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--color-text);
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: var(--transition-fast);
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: var(--color-surface-alt);
}

.service-header h1 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.header-placeholder {
  width: 44px;
}

/* 聊天容器 */
.chat-container {
  flex: 1 1;
  padding: 20px 16px;
  overflow-y: auto;
}

.chat-content {
  max-width: 600px;
  margin: 0 auto;
}

/* 消息项 */
.message-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
  gap: 12px;
}

.service-message {
  justify-content: flex-start;
}

/* 头像容器 */
.avatar-container {
  flex-shrink: 0;
}

.service-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--color-primary-light);
  box-shadow: var(--shadow-sm);
}

/* 消息气泡 */
.message-bubble {
  background: var(--color-surface);
  border-radius: 18px 18px 18px 6px;
  padding: 16px 18px;
  max-width: 280px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  position: relative;
}

.message-bubble::before {
  content: '';
  position: absolute;
  left: -8px;
  bottom: 12px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 8px 8px 0;
  border-color: transparent var(--color-surface) transparent transparent;
}

.message-text {
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--color-text);
  margin-bottom: 8px;
}

.message-time {
  font-size: 0.7rem;
  color: var(--color-text-sec);
  text-align: right;
}

/* 系统消息 */
.system-message {
  text-align: center;
  margin: 24px 0;
}

.system-text {
  display: inline-block;
  background: var(--color-surface-alt);
  color: var(--color-text-sec);
  font-size: 0.75rem;
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
}

/* 快捷操作 */
.quick-actions {
  margin: 32px 0;
  background: var(--color-surface);
  border-radius: 20px;
  padding: 20px 18px;
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
}

.action-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 16px;
  text-align: center;
}

.action-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.action-btn {
  background: var(--color-surface-alt);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px 12px;
  cursor: pointer;
  transition: var(--transition-fast);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-height: 80px;
  text-decoration: none;
}

.action-btn:hover {
  background: var(--color-primary-light);
  border-color: var(--color-primary);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.action-icon {
  font-size: 1.5rem;
}

.action-text {
  font-size: 0.8rem;
  color: var(--color-text);
  font-weight: 500;
}

/* 联系方式 */
.contact-info {
  background: var(--color-surface);
  border-radius: 20px;
  padding: 20px 18px;
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
  margin-bottom: 20px;
}

.contact-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 16px;
  text-align: center;
}

.contact-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-border);
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-label {
  font-size: 0.85rem;
  color: var(--color-text-sec);
  font-weight: 500;
}

.contact-value {
  font-size: 0.85rem;
  color: var(--color-text);
  font-weight: 600;
}

/* 底部输入区域 */
.chat-input-area {
  background: var(--color-surface);
  border-top: 1px solid var(--color-border);
  padding: 16px 20px;
  position: sticky;
  bottom: 0;
}

.input-placeholder {
  text-align: center;
  color: var(--color-text-sec);
  font-size: 0.8rem;
  padding: 12px;
  background: var(--color-surface-alt);
  border-radius: 12px;
  border: 1px solid var(--color-border);
}

/* 移动端响应式优化 */
@media (max-width: 480px) {
  .service-header {
    padding: 10px 16px;
  }

  .service-header h1 {
    font-size: 1rem;
  }

  .chat-container {
    padding: 16px 14px;
  }

  .service-avatar {
    width: 42px;
    height: 42px;
  }

  .message-bubble {
    max-width: 240px;
    padding: 14px 16px;
  }

  .message-text {
    font-size: 0.85rem;
  }

  .quick-actions, .contact-info {
    padding: 18px 16px;
    border-radius: 16px;
  }

  .action-buttons {
    gap: 10px;
  }

  .action-btn {
    padding: 14px 10px;
    min-height: 72px;
  }

  .action-icon {
    font-size: 1.3rem;
  }

  .action-text {
    font-size: 0.75rem;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .contact-label, .contact-value {
    font-size: 0.8rem;
  }
}

@media (max-width: 360px) {
  .chat-container {
    padding: 14px 12px;
  }

  .message-bubble {
    max-width: 200px;
    padding: 12px 14px;
  }

  .service-avatar {
    width: 38px;
    height: 38px;
  }

  .action-btn {
    min-height: 64px;
    padding: 12px 8px;
  }

  .action-icon {
    font-size: 1.2rem;
  }

  .action-text {
    font-size: 0.7rem;
  }
}


/* ============== FAQ 模态框优化 ============== */
.faq-modal {
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.faq-content-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-content {
  white-space: pre-wrap;
  overflow-y: auto;
  max-height: 60vh;
  padding-right: 8px; /* 为滚动条留出空间避免横向滚动 */
  word-break: break-word; /* 长词折行 */
  line-height: 1.75;
}

.faq-p { margin: 8px 0; }
.faq-sub { margin: 10px 0; font-weight: 600; color: var(--color-text); }
.faq-q {
  margin: 12px 0 8px;
  padding: 8px 10px;
  background: var(--color-surface-alt);
  border-left: 4px solid var(--color-primary);
  border-radius: 8px;
  font-weight: 700;
  color: var(--color-text);
}

.faq-hint {
  text-align: center;
  color: var(--color-text-sec);
  font-size: 0.8rem;
}

/* PC 端阅读密度稍放大 */
@media (min-width: 769px) {
  .faq-modal .modal-body { padding: 20px 24px; }
  .faq-content { max-height: 62vh; line-height: 1.8; }
  .faq-p { margin: 10px 0; }
}

/* 移动端优化：更大的行高与触摸友好间距 */
@media (max-width: 480px) {
  .faq-content { font-size: 0.92rem; line-height: 1.85; max-height: 58vh; }
  .faq-p { margin: 10px 0; }
  .faq-q { margin: 12px 0 10px; padding: 10px 12px; border-left-width: 3px; }
  .faq-hint { font-size: 0.75rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerServicePage.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAE,mBAAmB;EACvC,sBAAsB,EAAE,SAAS;EACjC,iBAAiB;AACnB;;AAEA,SAAS,aAAa,EAAE;AACxB,WAAW,cAAc,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACvE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,kBAAkB,EAAE;EAC7C,eAAe,gBAAgB,EAAE,gBAAgB,EAAE;EACnD,SAAS,cAAc,EAAE;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;EACxE,SAAS,cAAc,EAAE;EACzB,SAAS,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;EAC1E,YAAY,kBAAkB,EAAE;AAClC","sourcesContent":["/* 客服页面主容器 */\n.customer-service-page {\n  min-height: 100vh;\n  background: var(--color-bg);\n  display: flex;\n  flex-direction: column;\n}\n\n/* 页面头部 */\n.service-header {\n  background: var(--color-surface);\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--color-border);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  backdrop-filter: saturate(160%) blur(16px);\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--color-text);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: var(--transition-fast);\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.back-btn:hover {\n  background: var(--color-surface-alt);\n}\n\n.service-header h1 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.header-placeholder {\n  width: 44px;\n}\n\n/* 聊天容器 */\n.chat-container {\n  flex: 1;\n  padding: 20px 16px;\n  overflow-y: auto;\n}\n\n.chat-content {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* 消息项 */\n.message-item {\n  display: flex;\n  margin-bottom: 20px;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.service-message {\n  justify-content: flex-start;\n}\n\n/* 头像容器 */\n.avatar-container {\n  flex-shrink: 0;\n}\n\n.service-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--color-primary-light);\n  box-shadow: var(--shadow-sm);\n}\n\n/* 消息气泡 */\n.message-bubble {\n  background: var(--color-surface);\n  border-radius: 18px 18px 18px 6px;\n  padding: 16px 18px;\n  max-width: 280px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--color-border);\n  position: relative;\n}\n\n.message-bubble::before {\n  content: '';\n  position: absolute;\n  left: -8px;\n  bottom: 12px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 8px 8px 0;\n  border-color: transparent var(--color-surface) transparent transparent;\n}\n\n.message-text {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: var(--color-text);\n  margin-bottom: 8px;\n}\n\n.message-time {\n  font-size: 0.7rem;\n  color: var(--color-text-sec);\n  text-align: right;\n}\n\n/* 系统消息 */\n.system-message {\n  text-align: center;\n  margin: 24px 0;\n}\n\n.system-text {\n  display: inline-block;\n  background: var(--color-surface-alt);\n  color: var(--color-text-sec);\n  font-size: 0.75rem;\n  padding: 6px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n}\n\n/* 快捷操作 */\n.quick-actions {\n  margin: 32px 0;\n  background: var(--color-surface);\n  border-radius: 20px;\n  padding: 20px 18px;\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-sm);\n}\n\n.action-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.action-buttons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.action-btn {\n  background: var(--color-surface-alt);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-height: 80px;\n  text-decoration: none;\n}\n\n.action-btn:hover {\n  background: var(--color-primary-light);\n  border-color: var(--color-primary);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.action-icon {\n  font-size: 1.5rem;\n}\n\n.action-text {\n  font-size: 0.8rem;\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n/* 联系方式 */\n.contact-info {\n  background: var(--color-surface);\n  border-radius: 20px;\n  padding: 20px 18px;\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 20px;\n}\n\n.contact-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.contact-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.contact-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.contact-item:last-child {\n  border-bottom: none;\n}\n\n.contact-label {\n  font-size: 0.85rem;\n  color: var(--color-text-sec);\n  font-weight: 500;\n}\n\n.contact-value {\n  font-size: 0.85rem;\n  color: var(--color-text);\n  font-weight: 600;\n}\n\n/* 底部输入区域 */\n.chat-input-area {\n  background: var(--color-surface);\n  border-top: 1px solid var(--color-border);\n  padding: 16px 20px;\n  position: sticky;\n  bottom: 0;\n}\n\n.input-placeholder {\n  text-align: center;\n  color: var(--color-text-sec);\n  font-size: 0.8rem;\n  padding: 12px;\n  background: var(--color-surface-alt);\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n}\n\n/* 移动端响应式优化 */\n@media (max-width: 480px) {\n  .service-header {\n    padding: 10px 16px;\n  }\n\n  .service-header h1 {\n    font-size: 1rem;\n  }\n\n  .chat-container {\n    padding: 16px 14px;\n  }\n\n  .service-avatar {\n    width: 42px;\n    height: 42px;\n  }\n\n  .message-bubble {\n    max-width: 240px;\n    padding: 14px 16px;\n  }\n\n  .message-text {\n    font-size: 0.85rem;\n  }\n\n  .quick-actions, .contact-info {\n    padding: 18px 16px;\n    border-radius: 16px;\n  }\n\n  .action-buttons {\n    gap: 10px;\n  }\n\n  .action-btn {\n    padding: 14px 10px;\n    min-height: 72px;\n  }\n\n  .action-icon {\n    font-size: 1.3rem;\n  }\n\n  .action-text {\n    font-size: 0.75rem;\n  }\n\n  .contact-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .contact-label, .contact-value {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .chat-container {\n    padding: 14px 12px;\n  }\n\n  .message-bubble {\n    max-width: 200px;\n    padding: 12px 14px;\n  }\n\n  .service-avatar {\n    width: 38px;\n    height: 38px;\n  }\n\n  .action-btn {\n    min-height: 64px;\n    padding: 12px 8px;\n  }\n\n  .action-icon {\n    font-size: 1.2rem;\n  }\n\n  .action-text {\n    font-size: 0.7rem;\n  }\n}\n\n\n/* ============== FAQ 模态框优化 ============== */\n.faq-modal {\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.faq-content-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.faq-content {\n  white-space: pre-wrap;\n  overflow-y: auto;\n  max-height: 60vh;\n  padding-right: 8px; /* 为滚动条留出空间避免横向滚动 */\n  word-break: break-word; /* 长词折行 */\n  line-height: 1.75;\n}\n\n.faq-p { margin: 8px 0; }\n.faq-sub { margin: 10px 0; font-weight: 600; color: var(--color-text); }\n.faq-q {\n  margin: 12px 0 8px;\n  padding: 8px 10px;\n  background: var(--color-surface-alt);\n  border-left: 4px solid var(--color-primary);\n  border-radius: 8px;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.faq-hint {\n  text-align: center;\n  color: var(--color-text-sec);\n  font-size: 0.8rem;\n}\n\n/* PC 端阅读密度稍放大 */\n@media (min-width: 769px) {\n  .faq-modal .modal-body { padding: 20px 24px; }\n  .faq-content { max-height: 62vh; line-height: 1.8; }\n  .faq-p { margin: 10px 0; }\n}\n\n/* 移动端优化：更大的行高与触摸友好间距 */\n@media (max-width: 480px) {\n  .faq-content { font-size: 0.92rem; line-height: 1.85; max-height: 58vh; }\n  .faq-p { margin: 10px 0; }\n  .faq-q { margin: 12px 0 10px; padding: 10px 12px; border-left-width: 3px; }\n  .faq-hint { font-size: 0.75rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
